import React, { useState, FC } from 'react'
import './TableInlineTooltip.less'

export const TableInlineTooltip: FC<{ content: any }> = (props) => {
  const [show, setShow] = useState(false)

  return (
    <>
      {React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            onMouseLeave: () => {
              setShow(false)
            },
            onMouseEnter: () => {
              setShow(true)
            }
          })
        } else {
          return child
        }
      })}
      {show && (
        <div className="TableInlineTooltip">
          <div className="TableInlineTooltip__content">{props.content}</div>
          <div className="TableInlineTooltip__arrow" />
        </div>
      )}
    </>
  )
}
